export const MRC = "MRC";
export const DOM_01 = "DOM_01";
export const DOM_02 = "DOM_02";
export const KID_01 = "KID_01";
export const KID_02 = "KID_02";
export const ADN = "ADN";
export const ESP = "ESP";
export const ESP_KID = "ESP_KID";
export const IGLEKIDS = "IGLEKIDS";
export const YOUNG = "YOUNG";
export const PRIVATE = "PRV";

export const typeEvents = [
  {
    value: MRC,
    label: "Servicio de miércoles 7:30 PM",
  },
  {
    value: DOM_01,
    label: "Servicio de domingo 9 AM",
  },
  {
    value: DOM_02,
    label: "Servicio de domingo 11:30 AM",
  },
  {
    value: KID_01,
    label: "Iglekids domingo 9 AM",
  },
  {
    value: KID_02,
    label: "Iglekids domingo 11:30 AM",
  },
  {
    value: ADN,
    label: "Noche de ADN",
  },
  {
    value: ESP,
    label: "Evento especial",
  },
  {
    value: ESP_KID,
    label: "Evento especial de iglekids",
  },
  {
    value: YOUNG,
    label: "Young night",
  },
  {
    value: PRIVATE,
    label: "Evento especial privado",
  },
];
